var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6712 0.775004L4.10785 7.10917L2.36618 5.24834C2.04535 4.94584 1.54118 4.92751 1.17452 5.18417C0.817018 5.45001 0.716184 5.9175 0.936184 6.29334L2.99868 9.64834C3.20035 9.96 3.54868 10.1525 3.94285 10.1525C4.31868 10.1525 4.67619 9.96 4.87785 9.64834C5.20785 9.2175 11.5054 1.71 11.5054 1.71C12.3304 0.866671 11.3312 0.124171 10.6712 0.765838V0.775004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.cf96463d775bc3aaab509a6df4b7855f.svg";
export { ForwardRef as ReactComponent };